import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

import { FormattedFuturePayment } from '../../../../utils/mapper/futurepaymentsUtil';
import { CommonTransferState } from '../../form/CommonTransferState';

export interface TransferState extends CommonTransferState {
    transferDate?: ZonedDate;
}

export const transferInitialState: TransferState = {
    fromAccount: undefined,
    toAccount: undefined,
    showFromAccounts: false,
    showToAccounts: false,
    amount: undefined,
    note: '',
    ownText: undefined,
    transferDate: undefined,
};

export const getFutureState = (futurePayment: FormattedFuturePayment): TransferState => ({
    ...transferInitialState,
    transferDate: getZonedDate(futurePayment.date),
    note: futurePayment.description || '',
    amount: Math.abs(futurePayment.amount),
    showFromAccounts: false,
    showToAccounts: false,
    toAccount: futurePayment.toAccount.accountNumber,
});
